import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useNavigate, useParams } from "react-router-dom";
import { pageMotion } from "../../motion/pageMotion";
import { useDispatch } from "react-redux";
import Sidebar from "../../sidebar";
import { guardianAlertService } from "../../../services/guardianAlertService";
import { openAlertDetails } from "../../../utils/appNavigation";
import {
  getAlertSearchErrorMessage,
  isValidAlertCode,
  mapAlertByCodeToDetailsShape,
  normalizeAlertCode,
  pickTicketIdFromAlert,
} from "../../../utils/guardianAlertByCode";
import {
  MainContainer,
  SideContainer,
  PageContent,
  LoadingContainer,
  LoadingSpinner,
  EmptyMessage,
} from "./styles";
import { BackgroundPattern } from "../ListAreas/styles";
import AlertCodeSearchBar from "./AlertCodeSearchBar";

export default function AlertSearchByCode() {
  const { cod_alerta: routeCode } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const search = async () => {
      const code = normalizeAlertCode(routeCode);

      if (!isValidAlertCode(code)) {
        navigate("/view_alerts", { replace: true });
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const data = await guardianAlertService.getAlertByCode(code);

        if (!data?.success || !data?.alert) {
          setError("Nenhum alerta encontrado com este código.");
          return;
        }

        const alert = data.alert;
        const ticketId = pickTicketIdFromAlert(alert);
        const navigationState = { codAlerta: alert.cod_alerta };

        if (ticketId) {
          openAlertDetails(
            dispatch,
            navigate,
            { ...navigationState, ticketId },
            { replace: true }
          );
          return;
        }

        openAlertDetails(
          dispatch,
          navigate,
          {
            ...navigationState,
            preloadedAlert: mapAlertByCodeToDetailsShape(alert),
          },
          { replace: true }
        );
      } catch (err) {
        setError(getAlertSearchErrorMessage(err));
      } finally {
        setLoading(false);
      }
    };

    search();
  }, [dispatch, navigate, routeCode]);

  return (
    <MainContainer>
      <BackgroundPattern />
      <Sidebar />
      <SideContainer>
        <PageContent>
          <AnimatePresence mode="wait">
            {loading ? (
              <motion.div
                key="search-loading"
                initial={pageMotion.initial}
                animate={pageMotion.animate}
                exit={pageMotion.exit}
                transition={pageMotion.transition}
              >
                <LoadingContainer>
                  <LoadingSpinner />
                </LoadingContainer>
              </motion.div>
            ) : error ? (
              <motion.div
                key="search-error"
                initial={pageMotion.initial}
                animate={pageMotion.animate}
                exit={pageMotion.exit}
                transition={pageMotion.transition}
                style={{ width: "100%" }}
              >
                <EmptyMessage $error>{error}</EmptyMessage>
                <AlertCodeSearchBar initialCode={routeCode} />
              </motion.div>
            ) : null}
          </AnimatePresence>
        </PageContent>
      </SideContainer>
    </MainContainer>
  );
}
